var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8673,
    cy: 39.5587,
    r: 39.2345,
    fill: "url(#paint0_linear_1201_68625)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8673,
    cy: 39.5587,
    r: 37.2175,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 4.03397
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7384 56.3399C31.5928 56.3399 30.0602 54.654 30.0602 52.6616V25.6879C30.0602 23.7722 31.5928 22.0863 33.7384 22.0863C34.3514 22.0863 35.0411 22.2396 35.6541 22.6227L57.7235 36.1096C58.7964 36.7226 59.486 37.9487 59.486 39.1748C59.486 40.4775 58.7964 41.7035 57.7235 42.3166L35.6541 55.8034C35.0411 56.1866 34.3514 56.3399 33.7384 56.3399Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1201_68625",
    x1: 26.2496,
    y1: 78.7932,
    x2: 79.1018,
    y2: 25.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC962"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPlay);
export default __webpack_public_path__ + "static/media/yellowPlay.13df8d49f0c737798f7858e6c7b7b8b9.svg";
export { ForwardRef as ReactComponent };